import api from './api';

/**
 * Lien de suivi partagé d'un voyage (lot 053): créer, lire, retirer.
 * La page publique (`/shared/trip/:id?token=…`) se lit sans compte.
 */
const lire = (reponse) => reponse.data?.data;

export const lienSuiviAPI = {
  async lire(tripId) {
    return lire(await api.get(`/trips/${tripId}/share-link`, { skipToast: true }));
  },

  async creer(tripId) {
    return lire(await api.post(`/trips/${tripId}/share-link`));
  },

  async retirer(tripId) {
    return lire(await api.delete(`/trips/${tripId}/share-link`));
  },

  async lirePublic(tripId, token) {
    const reponse = await api.get(`/trips/${tripId}/shared`, { params: { token }, skipToast: true });
    return reponse.data;
  },
};

/** Adresse complète du lien: celle du serveur, sinon l'adresse de l'application. */
export const adresseDuLien = (lien) => {
  if (!lien?.active) return '';
  if (lien.url) return lien.url;
  const origine = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origine}${lien.path}`;
};

export default lienSuiviAPI;
